import { render, staticRenderFns } from "./categoryImgList.vue?vue&type=template&id=3170d322&scoped=true&"
import script from "./categoryImgList.vue?vue&type=script&lang=js&"
export * from "./categoryImgList.vue?vue&type=script&lang=js&"
import style0 from "./categoryImgList.vue?vue&type=style&index=0&id=3170d322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170d322",
  null
  
)

export default component.exports